import { render } from "./RegisterNewOrganisation.vue?vue&type=template&id=03d5b915"
import script from "./RegisterNewOrganisation.vue?vue&type=script&lang=js"
export * from "./RegisterNewOrganisation.vue?vue&type=script&lang=js"

import exportComponent from "/chi/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__